import React, {Component} from 'react';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import Duration from './Duration';
import PopoverEmbed from './PopoverEmbed';
import styles from './video-list.module.scss';

class VideoListItem extends Component {
  play = () => {
    let playFn = () => {};
    if (this.playFn) {
      playFn = this.playFn;
    }
    playFn();
  };

  setPlayFn = fn => {
    this.playFn = fn;
  };

  render() {
    const {video, isGridItem, useEmbed} = this.props;
    return (
      <div
        className={classNames(styles.VideoListItem, {
          'is-flex': !isGridItem,
          [styles['VideoListItem--in-vertical']]: !isGridItem,
          [styles['VideoListItem--in-grid']]: isGridItem,
        })}
      >
        {useEmbed ? (
          <PopoverEmbed
            className={styles.VideoListItem__thumbnail}
            setPlayFn={this.setPlayFn}
            video={video}
          />
        ) : (
          <img
            className={styles.VideoListItem__thumbnail}
            src={video.thumbnail.url}
          />
        )}
        <div className={styles.VideoListItem__details}>
          <p className={styles.VideoListItem__videoName} onClick={this.play}>
            {video.name}
          </p>
          <Duration seconds={video.duration} />
        </div>
      </div>
    );
  }
}

VideoListItem.propTypes = {
  isGridItem: PropTypes.bool,
  useEmbed: PropTypes.bool,
  video: PropTypes.shape({
    thumbnail: PropTypes.shape({
      url: PropTypes.string.isRequired,
    }).isRequired,
    duration: PropTypes.number.isRequired,
    hashed_id: PropTypes.string,
    name: PropTypes.string.isRequired,
  }).isRequired,
};

VideoListItem.defaultProps = {
  isGridItem: false,
  useEmbed: false,
};

export default VideoListItem;



// WEBPACK FOOTER //
// ./src/components/videos/VideoListItem.js